import { useMediaCounter } from '../hooks/useMediaCounter'

import { Box, Image, useDisclosure } from '@chakra-ui/react'

import { MediaPreviewerModal } from '../../feed/components/MediaPreviewerModal'
import { getFileName, getMimeType } from '../utils/imageHelpers'
import { MediaControls } from './MediaControls'
import { MediaError } from './MediaError'

export interface IncidentImagesIProps {
  images: string[]
}

export const IncidentImages = ({ images }: IncidentImagesIProps) => {
  const {
    index,
    isImageError,
    handleImageError,
    handleClickNext,
    handleClickPrevious,
  } = useMediaCounter({
    images,
  })
  const { isOpen, onOpen, onClose } = useDisclosure()

  const currentImageUrl = images?.[index]
  const selectedFile = currentImageUrl
    ? {
        id: currentImageUrl,
        url: currentImageUrl,
        name: getFileName(currentImageUrl),
        mimeType: getMimeType(currentImageUrl),
      }
    : null

  return (
    <Box
      data-testid='incidentsPage_drawer_incidentImages'
      pt='20px'
      px='24px'
      w='100%'
    >
      <MediaControls
        index={index}
        items={images}
        loading={false}
        onClickNext={handleClickNext}
        onClickPrevious={handleClickPrevious}
      >
        {!isImageError && (
          <Image
            borderRadius='4px'
            cursor='pointer'
            h='324px'
            objectFit='contain'
            onClick={onOpen}
            onError={handleImageError}
            src={currentImageUrl}
            w='100%'
          />
        )}
        {isImageError && <MediaError />}
      </MediaControls>
      {selectedFile && isOpen && (
        <MediaPreviewerModal
          file={selectedFile}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
    </Box>
  )
}
